import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import baseURL from "../utils/BaseURL";

const fetchLandingData = async () => {
  const headers = { "Content-Type": "application/json" };

  // Use Promise.all to fetch everything in parallel (faster)
  const [response, termsRes, policyRes] = await Promise.all([
    axios.get(`${baseURL}/landing_page`, { headers }),
    axios.get(`${baseURL}/legal_page`, { headers, params: { type: "terms" } }),
    axios.get(`${baseURL}/legal_page`, { headers, params: { type: "policy" } }),
  ]);

  const data = response.data;

  // Extract YouTube ID logic
  const videoId = data.section5_video_url?.match(
    /(?:v=|\/embed\/|youtu\.be\/)([^&?#/]+)/,
  )?.[1];
  const videoPath = `https://www.youtube.com/embed/${videoId}?enablejsapi=1`;

  // Return the same structure your components expect
  return {
    indexPageData: {
      header: {
        img: data.banner_content,
        part1: { title: data.title, desc: data.description },
        part2: {
          title: data.second_title,
          googlePlayImg: data.google_play_image1,
          appStoreImg: data.apple_store_image1,
          googlePlayLink: data.link1_url,
          appStoreLink: data.link2_url,
        },
      },
      aboutUs: {
        img: data.section2_image,
        title: data.section2_title,
        desc: data.section2_content,
      },
      chooseUs: {
        title: data.icon_big_title,
        cards: data.icon_sections.map((section) => ({
          icon: section.icon,
          title: section.title,
          desc: section.description,
        })),
      },
      appSection: {
        imgLeft: data.section4_image,
        imgCenter: data.google_play_image2,
        imgRight: data.apple_store_image2,
        bigTitle: data.section4_title,
        descTop: data.section4_description1,
        features: {
          f1: data.key_features[0]?.feature,
          f2: data.key_features[1]?.feature,
          f3: data.key_features[2]?.feature,
          f4: data.key_features[3]?.feature,
        },
        descBottom: data.section4_description2,
        googlePlayImg: data.image3,
        appStoreImg: data.image4,
        googlePlayLink: data.link3_url,
        appStoreLink: data.link4_url,
      },
      form: {
        bigTitle: data.big_phone_title,
        title: data.section6_title,
        desc: data.section6_text,
        phone: data.section6_phone,
        email: data.section6_email,
        address: data.section6_address,
        instagram: data.instagram_url,
        facebook: data.facebook_url,
      },

      footer: {
        copyright: data.footer_copyright,
        privacyPolicy: data.footer_privacy_policy,
        terms: data.terms,
        downloadAppTitle: data.footer_title,
        downloadAppDesc: data.footer_description,
        phone: data.footer_phone,
        email: data.footer_link1_text,
        logo: data.footer_icon,
        googlePlayImg: data.google_play_image3,
        appStoreImg: data.apple_store_image3,
        googlePlayLink: data.footer_link1_url,
        appStoreLink: data.footer_link2_url,
      },
    },
    terms: termsRes.data.result,
    privacy: policyRes.data.result,
  };
};

export const useLandingData = () => {
  return useQuery({
    queryKey: ["landing-page-data"],
    queryFn: fetchLandingData,
    staleTime: 1000 * 60 * 5, // Keep data fresh for 5 mins
  });
};
